import {SelectEntityItem} from 'components/SelectEntityItem'
import _ from 'lodash'
import React from 'react'
import {notEmpty} from 'views/Shared'
import {religiousOrderSchema} from "../../../apis";

const ReligiousOrderEntity = ({item, children, defaultItem}) => (
  <SelectEntityItem
    item={item}
    defaultItem={defaultItem}
    schema={religiousOrderSchema}>
    {(data) => children(data)}
  </SelectEntityItem>
)

export const ReligiousOrderEntities = ({items, children, defaultItem}) => (
  <SelectEntityItem
    item={items}
    defaultItem={defaultItem}
    schema={[religiousOrderSchema]}>
    {(data = []) => children(_.filter(data, notEmpty))}
  </SelectEntityItem>
)

export default ReligiousOrderEntity
